import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Hook to clear URL query parameters without reloading the page.
 */
const useClearQueryParams = () => {
  const navigate = useNavigate()

  const clearQueryParams = useCallback(() => {
    const { pathname } = window.location
    navigate(pathname, { replace: true })
  }, [navigate])

  return { clearQueryParams }
}

export default useClearQueryParams
